import { Dispatch, SetStateAction, FormEvent } from "react";

//ui
import { Flex, Text, useCheckbox, chakra } from "@chakra-ui/react";
import { CheckIcon } from "components/icons";

interface CheckBoxProps {
  value?: string;
  label?: string;
  setCheckBoxState?: Dispatch<SetStateAction<string[]>>;
  checkBoxState?: string[];
  setSelectState?: Dispatch<SetStateAction<string>>;
  selectState?: string;
}

export const CustomCheckBox = ({ value, label, setCheckBoxState, checkBoxState, selectState, setSelectState }: CheckBoxProps) => {
  const { state, getCheckboxProps, getInputProps, getLabelProps, htmlProps } = useCheckbox({ value });

  const handleChange = (e: FormEvent<HTMLLabelElement>) => {
    if (!setSelectState && setCheckBoxState) {
      if (!state?.isChecked) {
        setCheckBoxState(prev => (value && !prev.includes(value) ? [...prev, value] : prev));
      } else {
        const state = checkBoxState;
        if (state) {
          const presentState = state.filter(item => {
            return item !== value;
          });
          setCheckBoxState(prev => (presentState ? [...presentState] : prev));
        }
      }
    } else {
      if (value) setSelectState?.(value);
    }
  };

  const labelSelected = selectState === value;

  const getFontWeight = () => {
    if (!state.isChecked) return "400";
    if (!selectState || labelSelected) return "700";
    else return "400";
  };
  return (
    <chakra.label
      display="flex"
      alignItems="center"
      px="16px"
      py="10px"
      borderRadius="6px"
      gridColumnGap={2}
      width="100%"
      cursor="pointer"
      _hover={{
        bg: "rgba(137, 137, 199, 0.2)"
      }}
      _active={{
        border: "2px solid #5ED9D1"
      }}
      border={labelSelected ? "2px solid #8989C7" : ""}
      {...htmlProps}
      onChange={handleChange}
    >
      <input {...getInputProps()} hidden />
      <Flex
        alignItems="center"
        justifyContent="center"
        w={6}
        h={6}
        bg={state?.isChecked ? "blue.250" : "#d6d6d6"}
        borderRadius="6px"
        display={setSelectState ? "none" : "flex"}
        {...getCheckboxProps()}
      >
        {state.isChecked && <CheckIcon />}
      </Flex>
      <Text color="purple.100" mr="16px" fontWeight={getFontWeight()} {...getLabelProps()} whiteSpace="nowrap">
        {label}
      </Text>
    </chakra.label>
  );
};
